<script>
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import siteService from "@/services/sites";
import journeyService from "@/services/journey";
import { areaModes } from "@/utils/Constants";
import sitesService from "@/services/sites";
import userTypeService from "@/services/userType";
import { cloneDeep } from "lodash";

export default {
  name: "UpdateActionForm",
  data() {
    return {
      modal_id: null,
      formReady: false,
      isRemoteAreaMode: false,
      preSelectedUserType: [],
      userTypesOptions: [],
      siteJourneys: [],
      loading: true,
      siteInfoLength: null,
      journey: null,
      originalSelectedJourney: null,
      showOptions: false,
      loginModeOptions: [],

      signOutModeOptions: [
        { text: "At midnight", value: "at_midnight" },
        { text: "After 24 hours", value: "after_24_hours" },
      ],
      applyJourneyToOptions: [
        { text: this.$t('sitesAndDevices.allKiosks'), value: 1 },
        { text: this.$t('sitesAndDevices.inheritKiosks'), value: 0 },
      ],
      actionUponFireOptions: [
        { text: this.$t('sitesAndDevices.kioskActions.openDoor'), value: "open_door" },
        { text: this.$t('sitesAndDevices.noAction'), value: "no_action" },
      ],
      triggerFireValueOptions: [
        { text: this.$t('sitesAndDevices.highVoltage'), value: "high_voltage" },
        { text: this.$t('sitesAndDevices.lowVoltage'), value: "low_voltage" },
      ],
      activeAndPassiveConnectedOptions: [
        { text: "0", value: 0 },
        { text: "1", value: 1},
      ],
      area: { id: null, name: "Assigned As Parent" },
      areaOptions: [],
      form: {
        area: {
          name: null,
          description: null,
          login_mode: null,
          auto_sign_out: false,
          sign_out_mode: "at_midnight",
          auto_sign_out_email_notification: 0,
          user_type_ids: [],
          localSyncIPConfig: "",
          portNumber: null,
          fireAlarm: null,
          activeConnectedPort: false,
          activeConnectedPortNumber: 0,
          passiveConnectedPort: false,
          passiveConnectedPortNumber: 0,
          highVoltageThreshold : null,
          // IOportNumber: null,
          actionUponFireValue: "open_door",
          triggerFireValue: "high_voltage",
        },
        applayAll: 0,
      },
      submitted: false,
      enableBtn: false,
      areas: [],
      getIsSignInOutMode: false,
      getCountUsersSingnedIn: null,
      hasChildSignInOutAreaMessage : false,
      hasParentSignInOutAreaMessage : false,
      devicesHaveDiffJourney: false
    };
  },
  validations: {
    area: { required },
    journey: { required },
    form: {
      area: {
        name: {
          required,
          maxLength: maxLength(50),
        },
        description: {
          maxLength: maxLength(255),
        },
        login_mode: {
          required,
        },
        auto_sign_out: {},
        sign_out_mode: {},
        auto_sign_out_email_notification: {},
        user_type_ids: {
          requiredIf: function () {
            return (
              //valid cases
              !this.form.area.auto_sign_out ||
              !this.form.area.auto_sign_out_email_notification ||
              this.form.area.login_mode == "remote_checkIn_only" ||
              this.form.area.login_mode == "checkIn_only" ||
              (this.form.area.auto_sign_out_email_notification &&
                this.form.area.user_type_ids.length)
            );
          },
        },
        fireAlarm: {
          requiredIf: function () {
            return (!this.form.area.fireAlarm || (this.form.area.fireAlarm && (!!this.form.area.passiveConnectedPort || !!this.form.area.activeConnectedPort)));
          },
        },
        localSyncIPConfig: {},
        portNumber: {},
        // IOportNumber: {
        //   requiredIf: function () {
        //     return (
        //       !this.form.area.fireAlarm ||
        //       (this.form.area.fireAlarm && !!this.form.area.IOportNumber)
        //     );
        //   },
        // },
        activeConnectedPort: {},
        activeConnectedPortNumber: {},
        highVoltageThreshold : {
          requiredIf: function () {
            return (!this.form.area.fireAlarm || !this.form.area.activeConnectedPort || (this.form.area.activeConnectedPort && !!this.form.area.highVoltageThreshold));
          },
        },
        passiveConnectedPort : {},
        passiveConnectedPortNumber: {},
        actionUponFireValue: {},
        triggerFireValue: {},
      },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    modalTitle() {
      let title = "";
      if (this.areaMode === areaModes.NORMAL) {
        if (this.isEditArea) title = this.$t('sitesAndDevices.areaActions.editArea');
        else title = this.$t('sitesAndDevices.siteActions.addArea');
      } else if (this.areaMode === areaModes.REMOTE) {
        if (this.isEditArea) title = "Edit Remote Area";
        else title = this.$t('sitesAndDevices.siteActions.addRemoteArea');
      }
      return title;
    },
    // disableBtn() {
    //   const { name } = this.form.area;
    //   // check if the modal is for update area we dimit btn for name and journey else we add site with area
    //   return (
    //     this.siteInfoLength
    //       ? name && this.journey
    //       : name && this.area && this.journey && this.site
    //   )
    //     ? false
    //     : true;
    // },
    areaModes() {
      return areaModes;
    },
    isSignInOutModeSelected() {
      return (
        this.form.area.login_mode === "remote_signIn_signOut" ||
        this.form.area.login_mode === "signIn_signOut"
      );
    },
    journeyChanged() {
      // Return true if the selected journey is different from the original selected journey
      return (
        this.journey &&
        this.originalSelectedJourney &&
        this.journey.id !== this.originalSelectedJourney.id
      );
    },
    isParentAreaSignInOutMode(){
      return this.isEditArea ? false :this.area.loginMode === "signIn_signOut" || this.area.loginMode === "remote_signIn_signOut";
    }
  },
  watch: {
    async area(area) {
     await this.checkSignInOutInHierarchy(area);
    },
  },
  methods: {
    async checkSignInOutInHierarchy(area) {
      if (area && area.id) {
        const { data: data } = await siteService.checkSignInOutMode({
          //this.areaId => current area (in case of edit area)
          //area.id => parent area (in case of add area)
          id: this.isEditArea ? this.areaId : area.id,
          action: this.isEditArea ? "edit" : "add",
        });
        this.getIsSignInOutMode = data.haveParentAndChidernSignIn || area.loginMode == "signIn_signOut";
        this.hasChildSignInOutAreaMessage = data.haveChidernSignIn;
        this.hasParentSignInOutAreaMessage = data.haveParentSignIn;

        if (this.areaMode == areaModes.NORMAL) {
          if (this.getIsSignInOutMode) {
            this.loginModeOptions[1].disabled = true;
            this.form.area.login_mode = "checkIn_only";
            this.form.area.auto_sign_out = false;
          } else {
            this.loginModeOptions[1].disabled = false;
          }
        }
      } else {
        if (area.name == "Assigned As Parent") {
          this.$store.commit("sites/setIsSignInOutMode", false);
          if (this.areaMode == areaModes.NORMAL)
            this.loginModeOptions[1].disabled = false;

          this.hasChildSignInOutAreaMessage = false;
          this.hasParentSignInOutAreaMessage = false;
          this.getIsSignInOutMode = false;
        }
      }
      this.loading = false;
    },
    resetSubForm() {
      //Set "auto sign out" to false if "check in" is selected as area login mode
      if (
        this.form.area.login_mode == "checkIn_only" ||
        this.form.area.login_mode == "remote_checkIn_only"
      )
        this.form.area.auto_sign_out = false;

      // reset "user type" , "sign out mode" ,"email notification" if "auto sign out" is set to false
      if (!this.form.area.auto_sign_out) {
        this.form.area.user_type_ids = [];
        this.form.area.sign_out_mode = "at_midnight";
        this.form.area.auto_sign_out_email_notification = false;
      }
    },
    async updateJourney(journey) {
      if (journey) {
        if (this.isEditArea) {
          userTypeService.checkDevicesHaveDiffJourney(journey.id, this.getModalInfo.id).then((res) => {
            console.log('checkDevicesHaveDiffJourney', res);
            this.devicesHaveDiffJourney = res.data;
          });
        }
        const { data: userTypes } =
          await userTypeService.getPermittedUserTypeWithJourneyId(
            journey.id,
            this.isEditArea ? this.getModalInfo.id : 0
          );

        this.userTypesOptions = userTypes;

        if (journey?.id !== this.originalSelectedJourney?.id) {
          this.showOptions = true;
          // this.form.applayAll = 0;
          this.form.area.user_type_ids = [];
        } else {
          this.showOptions = false;
          // this.form.applayAll = null;
          //set "user type" to previously selected data if the same original journey is re-selected
          this.form.area.user_type_ids = cloneDeep(this.preSelectedUserType);
        }
      } else {
        this.form.area.user_type_ids = [];
        this.userTypesOptions = [];
      }
    },
    async onSubmit() {
      this.$v.$touch();
      console.log('errors', this.$v.$error)
      if (this.$v.$invalid) return;

      // if(!this.form.area.auto_sign_out || !this.form.area.login_mode)
      this.resetSubForm();

      this.submitted = true;
      this.form.area.journey_id = this.journey.id;
      this.form.area.site_id = this.site.id;
      this.form.area.parent_id = this.area.id;
      this.form.area.user_type_ids = this.form.area
        .auto_sign_out_email_notification
        ? this.form.area.user_type_ids
        : [];
      this.form.area.settings = {
        auto_sign_out: this.form.area.auto_sign_out ? 1 : 0,
        login_mode: this.form.area.login_mode,
        sign_out_mode: this.form.area.sign_out_mode,
        auto_sign_out_email_notification: this.form.area
          .auto_sign_out_email_notification
          ? 1
          : 0,
        local_sync_iP_configuration: this.form.area.localSyncIPConfig,
        port_number: this.form.area.portNumber,
        fire_alarm: this.form.area.fireAlarm,
        action_upon_fire: this.form.area.actionUponFireValue,
        trigger_fire_value_on: this.form.area.triggerFireValue,
        // io_connected_port_number: this.form.area.IOportNumber,

        active_io_connected_port: this.form.area.fireAlarm ? Number(this.form.area.activeConnectedPort) : 0 ,
        io_connected_port_number:  !!this.form.area.fireAlarm && !!this.form.area.activeConnectedPort ? this.form.area.activeConnectedPortNumber : 0,
        passive_io_connected_port: this.form.area.fireAlarm ? Number(this.form.area.passiveConnectedPort) : 0,
        passive_io_connected_port_number:  !!this.form.area.fireAlarm && !!this.form.area.passiveConnectedPort ? this.form.area.passiveConnectedPortNumber : 0,
        high_voltage_threshold: !!this.form.area.fireAlarm && !!this.form.area.activeConnectedPort ? this.form.area.highVoltageThreshold : null,

      };

      if (this.isEditArea)
        this.$emit(
          "updateArea",
          {
            id: this.areaId,
            params: this.form,
          },
          this.modal_id
        );
      else
        this.$emit(
          "createArea",
          {
            params: this.form,
          },
          this.modal_id
        );
    },
    setSettingsToDefault() {
      this.$v.form.area.actionUponFireValue.$model = "open_door";
      this.$v.form.area.triggerFireValue.$model = "high_voltage";
      // this.$v.form.area.IOportNumber.$model = null;
      this.form.area.activeConnectedPort = false;
      this.form.area.activeConnectedPortNumber = 0;
      this.form.area.highVoltageThreshold = null;
      this.form.area.passiveConnectedPort = false;
      this.form.area.passiveConnectedPortNumber = 0;
    },
    setSite() {
      if (this.isEditArea) this.site = this.getModalInfo.parentSite;
      else this.site = this.getModalInfo;
    },
    async setAreaOptions() {
      let payload = {
        site_id: this.site.id,
        is_remote: this.areaMode == this.areaModes.REMOTE ? 1 : 0,
      };

      const { data: areas } = await siteService.getAreasBysites(payload);

      this.areaOptions = areas;
      this.areaOptions.push({ id: null, name: "Assigned As Parent" });
    },
    // userTypeOptionLevels() {
    //   this.userTypesOptions.forEach((type,indx) => {
    //     if (type.parent_id) {
    //       const parentType = this.userTypesOptions.find(
    //         (t) => t.id == type.parent_id
    //       );
    //       if (parentType) {
    //         if (parentType.children) parentType.children.push(type);
    //         else parentType.children = [type];
    //         delete this.userTypesOptions[indx];
    //       }
    //     }
    //   });
    // },
    async setJourneysAndLoginModeOptions() {
      try {
        const areaMode = this.areaMode; //(remote OR normal)
        const siteId = this.site.id;

        //Set available journeys (REMOTE/NORMAL)
        let journeys = [];
        switch (areaMode) {
          case areaModes.NORMAL: {
            const { data } = await journeyService.getJourneysNormal(siteId);
            journeys = data;

            //Set login mode options
            this.loginModeOptions = [
              { text: this.$t('common.checkInOnly'), value: "checkIn_only", disabled: false },
              {
                text: this.$t('common.signInOut'),
                value: "signIn_signOut",
                disabled: false,
              },
            ];

            //set default login mode
            this.form.area.login_mode = "checkIn_only";
            break;
          }
          case areaModes.REMOTE: {
            const { data } = await journeyService.getJourneysRemote(siteId);
            journeys = data;

            //Set login mode options
            this.loginModeOptions = [
              {
                text: "Remote Sign in / Sign out",
                value: "remote_signIn_signOut",
                disabled: false,
              },
            ];

            //set default login mode
            this.form.area.login_mode = "remote_signIn_signOut";
            break;
          }
          default:
            throw new Error(`Unsupported area mode: ${areaMode}`);
        }

        this.siteJourneys = journeys || [];
      } catch (e) {
        console.error("Could not fetch data:", e);
      } finally {
        if(!this.isEditArea){
          this.loading = false;
        }
      }
    },
    async setUserTypesOptions(journeyId) {
      const { data: areaData } =
        await userTypeService.getPermittedUserTypeWithJourneyId(
          journeyId,
          this.getModalInfo.id
        );

      this.userTypesOptions = areaData || [];

      if (this.isEditArea) {
        this.userTypesOptions.forEach((userType) => {
          if (userType.isSelected)
            this.form.area.user_type_ids.push(userType.id);
          if (Array.isArray(userType.children) && userType.children.length) {
            userType.children.forEach((childUserType) => {
              if (childUserType.isSelected)
                this.form.area.user_type_ids.push(childUserType.id);
            });
          }
        });
        this.preSelectedUserType = cloneDeep(this.form.area.user_type_ids);
      }
    },
    async setArea() {
      let parentAreaId = this.getModalInfo?.parent_id;
      const { id, name, description, journey_id, settings } = this.getModalInfo;
      this.areaId = id;
      this.form.area.name = name;
      this.form.area.description = description;
      this.form.site_id = this.site.id;

      //Get parent area if 'parent_id' field exist on current area
      if (parentAreaId) {
        let payload = {
          site_id: this.site.id,
          is_remote: this.areaMode == this.areaModes.REMOTE ? 1 : 0,
        };
        const { data: currentAreasInSite } = await sitesService.getAreasBysites(
          payload
        );
        this.area = currentAreasInSite?.find((area) => area.id == parentAreaId);
      }else{
        await this.checkSignInOutInHierarchy({  id : this.getModalInfo.id } )
      }

      
      // journeys
      this.journey = this.siteJourneys.find(
        (journey) => journey.id == journey_id
      );
      this.originalSelectedJourney = cloneDeep(this.journey);
      // this.siteJourneys?.forEach((journey) => {
      //   journey.id == journey_id
      //     ? (this.journey = this.originalSelectedJourney = journey)
      //     : "";
      // });

      this.form.area.login_mode = this.getModalInfo.loginMode;
      this.form.area.auto_sign_out = !!this.getModalInfo.isAutoSignOut;
      this.form.area.sign_out_mode = this.getModalInfo.autoSignOut;
      this.form.area.auto_sign_out_email_notification =
        !!this.getModalInfo.auto_sign_out_email_notification;

      settings.forEach((setting) => {
        // console.log('setting', setting);
        let settingValue = setting.pivot.value;
        if (setting.name === "local_sync_iP_configuration")
          this.form.area.localSyncIPConfig = settingValue;
        else if (setting.name === "port_number")
          this.form.area.portNumber = settingValue;
        else if (setting.name === "fire_alarm")
          this.form.area.fireAlarm = Boolean(Number(settingValue));
        else if (setting.name === "action_upon_fire")
          this.form.area.actionUponFireValue = settingValue;
        else if (setting.name === "trigger_fire_value_on")
          this.form.area.triggerFireValue = settingValue;
        else if (setting.name === "active_io_connected_port")
          this.form.area.activeConnectedPort = Boolean(Number(settingValue));
        else if (setting.name === "io_connected_port_number")
          this.form.area.activeConnectedPortNumber = Number(settingValue);
        else if (setting.name === "high_voltage_threshold")
          this.form.area.highVoltageThreshold = settingValue;
        else if (setting.name === "passive_io_connected_port")
          this.form.area.passiveConnectedPort = Boolean(Number(settingValue));
        else if (setting.name === "passive_io_connected_port_number")
          this.form.area.passiveConnectedPortNumber = Number(settingValue);
      });
    },
  },
  async beforeMount() {
    this.isEditArea = this.getModalInfo.isEditArea;
    this.areaMode = this.getModalInfo.areaMode;
    this.modal_id = this.getModalInfo.modalId;
    console.log("this.getModalInfo", this.getModalInfo);
    this.isRemoteAreaMode = this.areaMode == areaModes.REMOTE;
    this.setSite();

    // Only fetch parent areas for normal area mode.
    /*
      All remote areas are set to 'sign in/out' 
      so there cannot be a parent and child with
      sign in/out area mode
    */
    if (!this.isRemoteAreaMode) await this.setAreaOptions();

    await this.setJourneysAndLoginModeOptions();

    //Set login mode to sign in/out by default if the area is remote.
    if(this.isRemoteAreaMode)
      this.form.area.login_mode = "remote_signIn_signOut";

    //Only set area data if 'edit' action is selected
    if (this.isEditArea) {
      await this.setUserTypesOptions(this.getModalInfo.journey?.id);
      await this.setArea();
      this.appliedJourney = cloneDeep(this.journey);

      const { data } = await sitesService.getCountUsersSingnedInApi(
        this.areaId
      );
      this.getCountUsersSingnedIn = data;
    }
    
    //set active connected port to 'true' by default if the 'fire alarm' is not selected
    if(!this.form.area.fireAlarm)
      this.form.area.activeConnectedPort = true;
    
    this.$v.$reset();
    this.formReady = true;
  },
};
</script>

<template>
  <div>
  <div class="vp-width-416 vp-mx-auto addEditArea" v-show="!loading && formReady">
    <template v-if="siteJourneys.length">
      <vpFormModal :id="modal_id + 'FormModal'" :showCloseIcon="false">
        <template v-slot:header>
          <span>
            {{ modalTitle }}
          </span>
        </template>

        <template v-slot:content>
          <vp-input
            v-model="site.name"
            :readOnly="true"
            :label="$t('common.site')"
            :disabled="true"
          />

          <vp-input
            id="name"
            v-model="$v.form.area.name.$model"
            :label="$t('sitesAndDevices.areaName')"
            maxlength="50"
            :disabled="submitted"
            :invalid="submitted && $v.form.area.name.$error"
          />

          <vp-textarea
            id="description"
            v-model="$v.form.area.description.$model"
            type="text"
            :label="$t('common.descriptionOptional')"
            maxlength="255"
            :disabled="submitted"
          />

          <vp-multiselect
            id="area"
            v-model="$v.area.$model"
            :options="areaOptions"
            :show-labels="false"
            width="422"
            :showPlaceholderIcon="true"
            :title="$t('sitesAndDevices.parentArea')"
            label="name"
            :allowEmpty="true"
            :disabled="submitted || isEditArea || isRemoteAreaMode"
            zIndex="3"
          />

          <p v-if="isEditArea" class="edit-area-note">
            <b>{{ $t('common.notes.note') }} : </b> {{ $t('sitesAndDevices.notes.changeParent') }}
          </p>

          <p v-if="getIsSignInOutMode && !siteInfoLength" class="edit-area-note">
            <template v-if="isParentAreaSignInOutMode">
              <b>{{ $t("common.notes.note") }}: </b>
              <template v-if="areaMode === areaModes.REMOTE">{{  $t("sitesAndDevices.notes.signInOutSelectedAreaRemote") }}</template>
              <template v-else>{{  $t("sitesAndDevices.notes.signInOutSelectedArea") }}</template>
            </template>

            <template v-if="hasParentSignInOutAreaMessage">
              <b>{{ $t("common.notes.note") }}: </b>
              <template v-if="areaMode === areaModes.REMOTE">{{  $t("sitesAndDevices.notes.signInOutParentRemote") }}</template>
              <template v-else>{{  $t("sitesAndDevices.notes.signInOutParent") }}</template>
            </template>
          </p>

          <vp-multiselect
            id="journey"
            v-model="$v.journey.$model"
            :options="siteJourneys"
            :showPlaceholderIcon="true"
            :title="$t('journeyBuilder.grid.journey')"
            :show-labels="false"
            label="name"
            width="422"
            :allowEmpty="true"
            :disabled="submitted"
            zIndex="2"
            @input="updateJourney"
          />

          <!-- <p v-if="isEditArea && journeyChanged" class="edit-area-note">
            <b>{{ $t('common.notes.note')}}:</b> {{ $t('sitesAndDevices.notes.autoSignOut') }}.
          </p> -->
          
          <div v-if="isEditArea && !isRemoteAreaMode && ((showOptions && devicesHaveDiffJourney) || (!showOptions && getModalInfo.devices_have_different_journey) )" class="vp-mt-34">
            <h5 class="form-label vp-mb-27">{{ $t('common.applyJourneyTo') }} </h5>
            <v-radio-group
              v-model="form.applayAll"
              :disabled="submitted"
              class="applyJourneyTo"
              @change="enableBtn = true"
            >
              <v-radio
                v-for="option in applyJourneyToOptions"
                :key="option.value"
                :label="option.text"
                :value="option.value"
              ></v-radio>
            </v-radio-group>
          </div>

          <div class="vp-mt-34">
            <h5 class="form-label vp-mb-27">{{ $t('common.loginMode') }} </h5>
            <v-radio-group
              v-model="$v.form.area.login_mode.$model"
              :disabled="submitted"
            >
              <v-radio
                v-for="option in loginModeOptions"
                :key="option.value"
                :label="option.text"
                :value="option.value"
                :disabled="option.disabled"
              ></v-radio>
            </v-radio-group>
          </div>

          <p
              v-if="
                getCountUsersSingnedIn &&
                (form.area.login_mode == 'checkIn_only' ||
                  form.area.login_mode == 'remote_checkIn_only') &&
                (getModalInfo.loginMode == 'signIn_signOut' ||
                  getModalInfo.loginMode == 'remote_signIn_signOut')
              "
              class="login-mode-note"
            >
              <b>{{ $t('common.notes.note') }}:</b>
              {{ $t('sitesAndDevices.notes.areaLoginMode')}}.
            </p>

            <p v-if="hasChildSignInOutAreaMessage" class="edit-area-note">
              <b>{{$t("common.notes.note")}}:</b> {{ $t('sitesAndDevices.notes.childAreaLoginMode')}}.
            </p>
          <div class="" v-if="isSignInOutModeSelected" style="margin-top: 34px;">
            <h5 class="form-label vp-mb-9">{{ $t('common.autoSignOut') }}</h5>
            <b-form-checkbox
              switch
              class="switch-gray custom-switch-input"
              size="lg"
              :disabled="submitted"
              v-model="$v.form.area.auto_sign_out.$model"
              style="padding-inline-start: 2.8rem !important; text-align: start;"
            />
          </div>

          <template
            v-if="
              isSignInOutModeSelected &&
              form.area.auto_sign_out &&
              (!getIsSignInOutMode || siteInfoLength)
            "
          >
            <v-radio-group
              v-model="$v.form.area.sign_out_mode.$model"
              class="vp-mb-7"
            >
              <v-radio
                v-for="option in signOutModeOptions"
                :key="option.value"
                :label="option.text"
                :value="option.value"
              ></v-radio>
            </v-radio-group>

            <b-form-group
              :disabled="submitted"
              v-if="isSignInOutModeSelected && form.area.auto_sign_out"
            >
              <b-form-checkbox
                v-model="$v.form.area.auto_sign_out_email_notification.$model"
                >{{ $t('sitesAndDevices.notes.notifyUsers') }}.</b-form-checkbox
              >
            </b-form-group>

            <template v-if="form.area.auto_sign_out_email_notification">
              <vpTreeselect
                v-model="$v.form.area.user_type_ids.$model"
                :disabled="!journey"
                :options="userTypesOptions"
                width="415"
                label="User Type"
              />
              <p class="edit-area-note">
                <b>{{ $t('common.notes.note') }}:</b> {{ $t('sitesAndDevices.notes.userTypes') }}
              </p>
            </template>
          </template>

          <hr class="vp-mt-30" />

          <template v-if="areaMode === areaModes.NORMAL">
            <VpInput
              :label="`${$t('sitesAndDevices.localSyncIpConf')} (${$t('common.optional')})`"
              width="416"
              v-model="$v.form.area.localSyncIPConfig.$model"
            />

            <VpInput
              :label="`${$t('sitesAndDevices.portNumber')} (${$t('common.optional')})`"
              width="416"
              type="number"
              v-model="$v.form.area.portNumber.$model"
            />

            <div class="setting-container">
              <span>{{  $t('sitesAndDevices.fireAlarm') }}</span>
              <b-form-checkbox
                class="switch-gray custom-switch-input"
                v-model="$v.form.area.fireAlarm.$model"
                switch
                size="lg"
              />
            </div>

            <p
              class="edit-area-note"
              :class="{
                'vp-mb-16': form.area.fireAlarm,
                'vp-mb-24': !form.area.fireAlarm,
              }"
            >
            <b>{{ $t('common.notes.note')}}:</b> {{ $t('sitesAndDevices.notes.fireAlarm') }} 
            </p>

            <p v-if="form.area.fireAlarm" class="edit-area-note vp-mb-16">
              <b>{{$t('common.notes.note')}}:</b> {{ $t('sitesAndDevices.notes.fireAlarmIO')}}.
            </p>

            <div v-if="form.area.fireAlarm" class="vp-mb-30">

              <div class="setting-container vp-mb-16">
                <span>{{$t('sitesAndDevices.activeIoConnectedPort')}}</span>
                <b-form-checkbox
                  class="switch-gray custom-switch-input"
                  v-model="$v.form.area.activeConnectedPort.$model"
                  switch
                  size="lg"

                />
              </div>

              <div v-if="form.area.activeConnectedPort">

                <h5 class="form-label vp-mb-27">{{ $t('sitesAndDevices.portNumber') }}</h5>

                <v-radio-group class="vp-mb-15" v-model="$v.form.area.activeConnectedPortNumber.$model">
                  <v-radio
                    v-for="option in activeAndPassiveConnectedOptions"
                    :key="option.value"
                    :label="option.text"
                    :value="option.value"
                  ></v-radio>
                </v-radio-group>
                
                <VpInput
                  :label="$t('sitesAndDevices.highVoltageThreshold')"
                  width="416"
                  type="number"
                  v-model="$v.form.area.highVoltageThreshold.$model"
                  class="vp-mb-16"
                />

              </div>

              <div class="setting-container vp-mb-16">
                <span>{{ $t('sitesAndDevices.passiveIoPort') }}</span>
                <b-form-checkbox
                  class="switch-gray custom-switch-input"
                  v-model="$v.form.area.passiveConnectedPort.$model"
                  switch
                  size="lg"

                />
              </div>  

              <div v-if="form.area.passiveConnectedPort">
                <h5 class="form-label vp-mb-27">{{ $t('sitesAndDevices.portNumber') }}</h5>

                <v-radio-group class="vp-mb-15" v-model="$v.form.area.passiveConnectedPortNumber.$model">
                  <v-radio
                    v-for="option in activeAndPassiveConnectedOptions"
                    :key="option.value"
                    :label="option.text"
                    :value="option.value"
                  ></v-radio>
                </v-radio-group>
              </div>
             
              <h5 class="form-label vp-mb-27">{{ $t('sitesAndDevices.actionUponFire') }} </h5>

              <v-radio-group
                v-model="$v.form.area.actionUponFireValue.$model"
                class="vp-mb-15"
              >
                <v-radio
                  v-for="option in actionUponFireOptions"
                  :key="option.value"
                  :label="option.text"
                  :value="option.value"
                ></v-radio>
              </v-radio-group>

              <h5 class="form-label vp-mb-27">{{ $t('sitesAndDevices.tiggerFireOn') }}</h5>

              <v-radio-group v-model="$v.form.area.triggerFireValue.$model">
                <v-radio
                  v-for="option in triggerFireValueOptions"
                  :key="option.value"
                  :label="option.text"
                  :value="option.value"
                ></v-radio>
              </v-radio-group>
            </div>
            <hr class="vertical-line"/>
          </template>
        </template>

        <template v-slot:footer>
          <!-- <div> -->
          <button
            :disabled="submitted || $v.$invalid || (!$v.$anyDirty && !enableBtn)"
            size="md"
            @click="onSubmit"
            class="confirm-btn"
          >
            <i v-if="submitted"></i>
            {{ isEditArea ? $t('common.edit') : $t('common.add') }}
          </button>
          <button
            :class="{ 'cursor-stop': submitted }"
            :disabled="submitted"
            @click="$bvModal.hide(modal_id)"
            class="cancel-btn"
          >
            {{ $t('common.cancel') }}
          </button>
          <!-- </div> -->
        </template>
      </vpFormModal>
    </template>

    <template v-else>
      <VpConfirmModal :modalId="modal_id">
        <template v-slot:title>
          <span>
            {{ areaMode === areaModes.NORMAL ? $t('sitesAndDevices.siteActions.addArea') : $t('sitesAndDevices.siteActions.addRemoteArea') }}
          </span>
        </template>

        <template v-slot:text1>
          <span> {{$t('sitesAndDevices.notes.noJourneys')}}. </span>
        </template>

        <template v-slot:text2>
          <span>
            {{$t('sitesAndDevices.notes.noJourneysMsg',{site:site.name})}}.
          </span>
        </template>

        <template v-slot:buttons>
          <VpButton
            :text="$t('common.okay')"
            :disabled="submitted"
            @click="$bvModal.hide(modal_id)"
          />
        </template>
      </VpConfirmModal>
    </template>
  </div>
  <div  v-if="loading || !formReady" class="site-area-spinner-container d-flex justify-content-center">
    <b-spinner
      class="site-area-spinner"
      variant="primary"
      role="status"
    />
    </div>
  </div>
</template>

<style lang="scss">
div[id*="confirmModal___BV_modal_content_"] {
  border-radius: 26px !important;
}
div[id*="confirmModal___BV_modal_body_"] {
  overflow-x: hidden !important;
}
// :dir(rtl) .addEditArea .custom-control-input:checked~.custom-control-label:after {
//   inset-inline-start: -5px !important;
// }
// :dir(ltr) .addEditArea .custom-control-input:checked~.custom-control-label:after {
//   inset-inline-start: -34px !important;
// }
.site-area-spinner-container .site-area-spinner{
    width: 80px;
    height: 80px;
}
.addEditArea {
  .applyJourneyTo .v-input--radio-group__input {
    display: grid;
    gap: 16px;
  }
  .form-label {
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #787878;
    text-align: start;
  }
  .edit-area-note {
    color: #939393;
    line-height: 23.5px;
    letter-spacing: 0.25px;
    font-size: 14px;
    margin-top: -10px;
  }
  .login-mode-note{
    width : 391px;
    text-align: center; 
    color: #939393;
    line-height: 23.5px;
    letter-spacing: 0.25px;
    margin-top: 30px;
  }
  .setting-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 416px;
    height: 55px;
    padding: 22px 20px 21px;
    background-color: #f2f2f2;

    span {
      font-size: 16px;
      font-weight: 700;
      line-height: 19.2px;
      color: #787878;
    }
  }

  .switch-gray {
  .custom-control-input:checked ~ .custom-control-label::before {
    position: absolute;
    top: 6px !important;
    width: 43px;
    height: 21px;
    background: #D1D1D1;
    border: 1.5px solid #D1D1D1!important;
    border-radius: 13.5px

  }

  .custom-control-input:checked ~ .custom-control-label::after{
    width: 21px!important;
    height: 21px!important;
    top: 6px!important;
    background-color: #34C38F;
  }
   
  .custom-control-label::before{
    top: 6px !important;
    width: 43px!important;
    height: 21px!important;
    background: #D1D1D1;
    border: 1.5px solid #D1D1D1!important;
    border-radius: 13.5px
  }
  .custom-control-label::after{
    width: 21px!important;
    height: 21px!important;
    top: 6px!important;
    background: #939393;
    box-shadow: -1px 0px 3px rgba(0, 0, 0, 0.18) !important;
  }

}
}
// }
</style>
